export const en = {
  global: {
    nav_menu: {
      company: "Our Company",
      company_submenu: {
        our_company: "Our Company",
        about_us: "About Us",
        our_history: "Our History",
        our_culture: "Our Culture",
        our_values: "Our Values",
        our_plataform: "Our Platform",
        our_plants: "Our Plants",
        global_presence: "Global Presence",
      },
      services_units: "Our Services Units",
      solutions: "Our Products",
      solutions_submenu: {
        solutions: "Our Products",
        herbicide: "Herbicide",
        fungicide: "Fungicide",
        insecticide: "Insecticide",
        plan_growth_regulator: "Plan Growth Regulator",
        seeds_treatment: "Seeds Treatment",
        biosolutions: "Bio Solutions",
        bio_solutions: "Bio Solutions",
        bio_solution: "Bio Solutions",
        crop_protection: "Crop Protection",
        enviro_solutions: "Enviro Solutions",
        non_crop: "Enviro Solutions",
      },
      news: "news",
      contact_us: "contact us",
      services_units_submenu: {
        our_services_units: "All Services Units",
        smart_growing: "Smart Growing",
        business_partners: "Business Partners",
        bio_solutions: "Bio Solutions",
        noncrop_solutions: "Enviro Solutions",
        design_studio: "Design Studio",
      },
    },
    footer: {
      title: "We’re a fully integrated global crop protection company.",
      copyright: "Copyright © Rainbow Agro.",
      privacy_policy: "Privacy Policy",
      terms_of_use: "Terms of use",
      download_report: "Download the last report",
      legal_and_press: "Legal & Press",
      social_media: "Social Media",
    },
    contact_form: {
      name: {
        label: "Name",
        placeholder: "Enter your name",
      },
      email: {
        label: "Email",
        placeholder: "Enter your email",
      },
      country: {
        label: "Country / Area",
        placeholder: "Select Country / Area",
      },
      role: {
        label: "Role",
        placeholder: "Select your role",
      },
      linkedin_url: {
        label: "LinkedIn Profile URL",
        placeholder: "Enter your LinkedIn profile URL",
      },
      message: {
        label: "Message",
        placeholder: "Enter your message",
      },
      submit_button: "Send Message",
      marketing_consent_label:
        "I agree to the use of my email for marketing campaigns.",
      agreement_text:
        "All the fields are required. By sending the form you agree to the",
      terms_link: "Terms & Conditions",
      and: "and",
      privacy_link: "Privacy Policy",
      errors: {
        name: "Name is required",
        email: "Email is required",
        country: "Country / Area is required",
        role: "Role is required",
        message: "Message is required",
        min_name: "Name must be at least 3 characters",
        invalid_email: "Please enter a valid email address",
        invalid_url: "Please enter a valid LinkedIn URL",
        required_url: "LinkedIn URL is a required field",
      },
    },
  },
  home_page: {
    about_section: {
      title: "Our Mission",
      headline: "To be your best partner for growth",
      link: "Learn more about us",
      purpose: {
        title: "Our Purpose",
        paragraph_1:
          "We create value by connecting every step of the agricultural supply chain, to enable us all to work better together.",
        paragraph_2:
          "Our purpose is to encourage all players to embrace agriculture with a collective approach, moving away from a solitary perspective. We believe that only by working together can we truly achieve the success and sustainability that agriculture demands.",
        quote_1:
          "We grow to create a better future, we grow together because together we can build it.",
        quote_2: "",
      },
    },
    team_section: {
      main_quote:
        "We are a global company with local reach, offering our solutions across 100+ countries",
      description:
        "Designed to meet the diverse needs of farmers, distributors, and industry partners.",
    },
    our_services_section: {
      title: "our services units",
      headline: "From big businesses to small scale farmers",
      description:
        "We deliver fast and flexible solutions to meet the needs of every customer.",
      services: {
        item1: {
          title: "Smart Growing",
          description:
            "Smart Growing is our business unit dedicated to developing solutions focused on growers' needs. We offer customers a comprehensive portfolio, reliable delivery, and expert technical support, building long-term relationships to ensure our solutions enables smarter, sustainable growth.",
        },
        item2: {
          title: "Business Partners",
          description:
            "Exclusively focused on B2B, Business Partners recognizes that every customer is unique. We provide adaptable business models that flexibly address specific needs. Our value lies in the speed of delivering our extensive portfolio and the flexibility to consistently create value for our partners.",
        },
        item3: {
          title: "Bio Solutions",
          description:
            "At Rainbow Bio, we bring cutting-edge biological solutions to farmers worldwide, combining innovation with sustainability. No matter where you are, we help you grow stronger, smarter, and more sustainably—driving the future of agriculture for a resilient tomorrow.",
        },
        item4: {
          title: "Enviro Solutions",
          description:
            "We specialize in innovative Enviro protection solutions that enhance green spaces for our communities and society. We safeguard people and environments from pests, diseases, and weeds, while protecting surrounding ecosystems.",
        },
        item5: {
          title: "Design Studio",
          description:
            "We connect customers with the strength and resources of Global Rainbow, creating a space to engage, understand their needs, and collaboratively design supply chain solutions based on our full-spectrum capabilities.",
        },
      },
      button: "Contact us",
    },
    facts_section: {
      headline: "Let's grow together!",
      description:
        "Founded in 2000, we’ve grown into one of the world’s top ten crop protection companies worldwide with 9 factories, 2 R&D centers and 1 Process Development Center.",
      item1: {
        value: "7,000+",
        label: "Registration Worldwide",
      },
      item2: {
        value: "5,000+",
        label: "Production Formulas",
      },
      item3: {
        value: "300+",
        label: "Patents",
      },
      item4: {
        value: "100+",
        label: "Countries Presence",
      },
      button: "Learn more",
    },
    our_products_section: {
      title: "our solutions",
      headline: "Your one stop shop for complete solutions",
      description:
        "We offer solutions to protect crops from all types of weeds, pests, and diseases at every stage of growth.",
    },
    paragraph_section: {
      description:
        "We've built a versatile platform that provides cost-effective solutions for agricultural players, from major crop protection companies to independent growers, offering a strong portfolio, convenient value, efficient services, and a reliable partnership.",
      button: "Contact Us",
    },
    split_section: {
      headline: "Shaping the future of sustainable agriculture.",
      description_regular_1: "Because by ",
      description_color_1: "adopting biologicals",
      description_regular_2: ", you stay ahead of ",
      description_color_2: "ever-tightening global",
      description_regular_3:
        "regulations on chemical use, keeping your products",
      description_color_3: "compliant and competitive",
      description_regular_4: " in key export markets.",
      features: {
        feature_1: "Strategic Partners",
        feature_2: "R & D",
        feature_3: "Technical Expertise",
        feature_4: "Global Portfolio Management",
      },
      button: "Learn More",
    },
    enviro_section: {
      headline: "Solutions that protect environments where we work, live and play.",
      description: "Trusted by the professionals delivering performace, protection, and healthier environments.",
      feature_title: "Our Portfolio",
      features: {
        feature_1: "Turf and Landscape",
        feature_2: "Professional Pest Management",
        feature_3: "Ornamentals",
      },
      button: "Learn More",
      button_link: "/enviro-solutions",
    },
    testimonials_section: {
      headline_title_1: `You might like someone else's`,
      headline_title_2_effect: `point of vi`,
      headline_title_2_no_effect: `ew`,
    },
    features_section: {
      headline_text_white_1: `We believe that`,
      headline_text_green: `together we can grow`,
      headline_text_white_2: `a better future`,
    },
    values_section: {
      title: "Our values",
      description:
        "At Rainbow, we promote these values in our daily activities, both internally and when engaging with our partners, clients, suppliers, and all types of stakeholders.",
      values: {
        value_1: {
          title: "Customer Oriented",
          description:
            "We understand our customers' key needs, focusing on tailored solutions to maximize value and meet each requirement.",
        },
        value_2: {
          title: "Rapid Response",
          description:
            "Rapid response to customer needs and market changes is our philosophy, enabling steady growth in global markets.",
        },
        value_3: {
          title: "Constant Effort",
          description:
            "Effort and continuous learning define us, enabling us to face challenges confidently and build trust.",
        },
        value_4: {
          title: "Open and Inclusive",
          description:
            "An open, inclusive mindset toward cultures and ideas fuels our innovation and steady growth.",
        },
        value_5: {
          title: "Together We Work",
          description:
            "Teamwork boosts cross-cultural cooperation and efficiency, thanks to the combined efforts of all teams.",
        },
        value_6: {
          title: "Together We Win",
          description:
            "Rainbow’s growth stems from employee effort and partner support; we are grateful to share our success.",
        },
      },
      button: "Contact us",
    },
    value_proposal_section: {
      title: "value proposal",
      headline: "Why choose Rainbow?",
      values: {
        item1: {
          title: "Portfolio Strength",
          description:
            "With over 5,000 formulations and 7,000 registrations worldwide, we offer solutions that address crop challenges at every growth stage.",
        },
        item2: {
          title: "Convenient Value",
          description:
            "From concept to delivery, our end-to-end approach ensures full control over product quality while achieving cost efficiencies across the entire supply chain.",
        },
        item3: {
          title: "Efficient Services",
          description:
            "Our customer-centric culture ensures high-quality services that address what matters the most to customers and growers.",
        },
        item4: {
          title: "Reliable Partnership",
          description:
            "We build trust by consistently delivering on commitments, fostering strong, long-term customer relationships.",
        },
      },
      button: "Learn More",
    },
    blog_section: {
      title: "our blog",
      headline: "The latest news",
      link: "Read more in our blog",
    },
    newsletter_section: {
      title: "Stay informed with our newsletter",
      placeholder: "Enter your email",
      button: "Subscribe Now",
      agreement_text: "By sending the form you agree to the",
      terms_link: "Terms & Conditions",
      and: "and",
      privacy_link: "Privacy Policy",
      subscribing_message: "Thank you for subscribing to our newsletter!",
    },
    contact_section: {
      headline: "Let’s talk",
      description:
        "We’re here to help you grow. Fill out the form below, and one of our experts will get in touch with you shortly. Let’s start building something great together!",
      contact_info: {
        say_hello: "Say hello",
        location: "Location",
      },
    },
  },
  company_page: {
    hero: {
      title: "our company",
      headline: "Comprehensive end-to-end offering",
    },
    section_1: {
      serv_1: {
        nav: "About Us",
        content: {
          col_1:
            "We are a global crop protection company offering a business platform of flexible and cost-effective solutions to meet the diverse needs of farmers, distributors, and industry partners.",
          col_2:
            "We operate in over 100 countries across five continents, united by our shared belief in building a better future together. Each market we serve presents unique challenges, inspiring us to develop flexible solutions tailored to the needs of industrial companies, distributors, and farmers.",
          col_3:
            "Our commitment to adding value at every stage of the agricultural chain drives us to support our partners with expertise and dedication, seamlessly blending global strength with local professionalism to deliver exceptional performance and efficiency.",
        },
      },
      serv_2: {
        nav: "Our history",
        content: {
          col_1:
            "Founders signing the foundation contract in 2000, Jinan, Shandong Province, China. They currently hold the following positions: Cathy, Commercial VP; Hardy, Operation & Supply Chain VP; Sun Guoqing, Board Director; Wicky Wang, CEO; Hou Juzhen, shareholder; and Leo, CTO.",
          col_2: {
            paragraph_1:
              "Rainbow was founded by six chemical engineers who worked together in a China state-owned company since 1994. The current CEO was quickly promoted from factory worker, to production manager, to technical manager, and to general manager.",
            paragraph_2:
              "The six founders were raised in poor environments and had deep memories about growing up with not enough food. They didn’t want to repeat the story, so they put together all their savings and decided to start their own business, with one simple purpose:.",
            last_phrase: "to make a better future.",
          },
          col_3: {
            paragraph_1:
              "They asked for the government to rent them a factory that was out of business. When the authorities knew who they were and got to know their backstories, they accepted the request. But they also fixed the production line, made an investment, and rented them the factory for free.",
            paragraph_2:
              "The only condition was to keep the former employees' jobs. And that’s how in 2000, at the same time that China was becoming the factory of the whole world, the six colleagues started their own business without money but working really hard",
            last_phrase: "together.",
          },
        },
      },
      serv_3: {
        nav: "Our culture",
        content: {
          col_1:
            "We believe in the power of connection. Our essence lies in providing flexible and reliable solutions that strengthen these connections, driving collective growth all around the world.",
          col_2: {
            paragraph_1: {
              title: "Trust is our top priority",
              text: "We believe in building long-term relationships by consistently delivering on our commitments. Growers rely on the quality of our products, and we value that reliability. By respecting channel strategies and supporting entrepreneurs, we ensure the success of all our partners.",
            },
            paragraph_2: {
              title: "Global reach, local relevance",
              text: "We are a global company with a diverse network of skilled professionals united by a shared purpose. While our reach is worldwide, we work for local relevance, combining global support with tailored solutions to meet specific needs. Together, we think and act as one global cohesive team with local expertise.",
            },
          },
          col_3: {
            paragraph_1: {
              title: "Agility fueled by collaboration",
              text: "We embrace an entrepreneurial spirit that drives innovation and adaptability. Through seamless collaboration and open communication within our network and with our partners, we work in an agile and flexible manner to move quickly and efficiently. We avoid bureaucracy and remain committed to maintaining our entrepreneurial spirit, even as our company continues to grow.",
            },
          },
        },
      },
      serv_4: {
        nav: "Our platform",
        content: {
          col_1:
            "Rainbow’s Business Solution Platform is at the service of our customers, ready to deliver flexible and cost-effective solutions to any Agro-player needs.",
        },
        link: "Learn more",
      },
    },
    section_2: {
      title: "GLOBAL PRESENCE",
      headline: "Let's grow together!",
      subtitle:
        "We bring the strengths of a global full-spectrum company with the dedication and professionalism of our local teams, ensuring high performance, efficient service, and product delivery to address each of our clients’ needs.",
      numbers: {
        description_1: "Plants",
        description_2: "R&D Centers",
        description_3: "Process Development Center",
        description_4: "Countries",
      },
      button: "Contact us",
    },
    section_3: {
      headline: "Our Plants and R&D centers",
      subtitle:
        "We’ve grown into one of the world’s top ten crop protection companies worldwide with 9 factories, 2 R&D centers, and 1 Process Development Center.",
    },
    section_4: {
      title: "GLOBAL PRESENCE",
      headline: "Find your country / Area",
      subtitle: "We’re wherever you need us.",
      form_country_placeholder: "Select Your Country / Area",
      form_country_label: "Country / Area",
      form_country_link: "See available products"
    },
    section_5: {
      headline: "Our values",
      subtitle:
        "At Rainbow, we promote these values in our daily activities, both internally and when engaging with our partners, clients, suppliers, and all types of stakeholders.",
      values: {
        value_1: {
          title: "Customer Oriented",
          description:
            "We understand our customers' key needs, focusing on tailored solutions to maximize value and meet each requirement.",
        },
        value_2: {
          title: "Rapid Response",
          description:
            "Rapid response to customer needs and market changes is our philosophy, enabling steady growth in global markets.",
        },
        value_3: {
          title: "Constant Effort",
          description:
            "Effort and continuous learning define us, enabling us to face challenges confidently and build trust.",
        },
        value_4: {
          title: "Open and Inclusive",
          description:
            "An open, inclusive mindset toward cultures and ideas fuels our innovation and steady growth.",
        },
        value_5: {
          title: "Together We Work",
          description:
            "Teamwork boosts cross-cultural cooperation and efficiency, thanks to the combined efforts of all teams.",
        },
        value_6: {
          title: "Together We Win",
          description:
            "Rainbow’s growth stems from employee effort and partner support; we are grateful to share our success.",
        },
      },
      button: "Contact us",
    },
    section_6: {
      headline: "Our business report",
      paragraph_1:
        "Explore Rainbow’s achievements, growth, and vision for the future. Our business report provides detailed insights into our performance, strategic initiatives, and the impact we’ve made globally.",
      paragraph_2:
        "Download the full report to discover how we continue to grow together, innovate, and lead the way in the agricultural industry.",
      button: "Download the last report",
    },
  },
  services_units: {
    hero: {
      title: "OUR SERVICES UNITS",
      headline: "From big businesses to small scale farmers",
      description:
        "We deliver fast and flexible solutions to meet the needs of every customer.",
      button: "DISCOVER NOW",
      link: "Contact Us",
    },
    section_1: {
      button: "LEARN MORE",
      services: {
        item1: {
          title: "Smart Growing",
          description:
            "Smart Growing is our business unit dedicated to developing solutions focused on growers' needs. We offer customers a comprehensive portfolio, reliable delivery, and expert technical support, building long-term relationships to ensure our solutions enables smarter, sustainable growth.",
        },
        item2: {
          title: "Business Partners",
          description:
            "Exclusively focused on B2B, Business Partners recognizes that every customer is unique. We provide adaptable business models that flexibly address specific needs. Our value lies in the speed of delivering our extensive portfolio and the flexibility to consistently create value for our partners.",
        },
        item3: {
          title: "Bio Solutions",
          description:
            "At Rainbow Bio, we bring cutting-edge biological solutions to farmers worldwide, combining innovation with sustainability. No matter where you are, we help you grow stronger, smarter, and more sustainably—driving the future of agriculture for a resilient tomorrow.",
        },
        item4: {
          title: "Enviro Solutions",
          description:
            "We specialize in innovative crop protection solutions that enhance green spaces for our communities and society. We safeguard people and environments from pests, diseases, and weeds, while protecting surrounding ecosystems.",
        },
        item5: {
          title: "Design Studio",
          description:
            "We connect customers with the strength and resources of Global Rainbow, creating a space to engage, understand their needs, and collaboratively design supply chain solutions based on our full-spectrum capabilities.",
        },
      },
    },
    section_2: {
      headline_title_1: `You might like someone else's`,
      headline_title_2_effect: `point of vi`,
      headline_title_2_no_effect: `ew`,
    },
    section_3: {
      title: "value proposal",
      headline: "Why choose Rainbow?",
      values: {
        item1: {
          title: "Portfolio Strength",
          description:
            "With over 5,000 formulations and 7,000 registrations worldwide, we offer solutions that address crop challenges at every growth stage.",
        },
        item2: {
          title: "Convenient Value",
          description:
            "From concept to delivery, our end-to-end approach ensures full control over product quality while achieving cost efficiencies across the entire supply chain.",
        },
        item3: {
          title: "Efficient Services",
          description:
            "Our customer-centric culture ensures high-quality services that address what matters the most to customers and growers.",
        },
        item4: {
          title: "Reliable Partnership",
          description:
            "We build trust by consistently delivering on commitments, fostering strong, long-term customer relationships.",
        },
      },
      button: "Learn More",
    },
  },
  smart_growing_page: {
    hero: {
      title: "smart growing",
      headline: "Developing solutions focused on growers needs",
      button_1: "OUR SOLUTIONS",
      button_2: "GET IN TOUCH",
    },
    section_1: {
      text_regular_1:
        "Aligned with our purpose, we add value to the agricultural supply chain by focusing on areas where we can make the greatest impact. We aim for the complete success of our partners",
      text_color_1: "—distributors and retailers—",
      text_regular_2:
        "building long-term relationships that ensure our products reach growers' hands when they need them most.",
    },
    section_2: {
      subtitle:
        "Established in 2015, Smart Growing operations began in Central America, Malaysia and Ghana and now operates in 55 countries, providing Rainbow products to farmers through distributors and/or retailers.",
      text: `We offer a one - stop shop for distributors, retailers, and growers, supported by an extensive portfolio that addresses all crop challenges at every stage.Our portfolio expands continuously, with over 1, 200 new registrations added globally each year.Our expert regulatory team ensures swift and compliant submissions, tailored to meet local requirements.

Our strength extends beyond our robust portfolio.As a full - spectrum CP provider, we manage the entire process from design to delivery.We synthesize some active ingredients(AIs) in -house, and for those we don’t, we’ve established strategic partnerships with key industry suppliers to source them effectively.This comprehensive approach ensures rigorous quality control and delivering world class product standards and unmatched value to our customers.`,
      button: "Contact us",
    },
    section_3: {
      headline: "Let's grow together!",
      description:
        "If you're looking for a way to expand your solutions offering, centered around your customers' needs, you should contact us.",
      item1: {
        // value: "7,000+",
        label: "7,000+ Registrations worldwide",
      },
      item2: {
        // value: "5,000+",
        label: "2+ Research center",
      },
      item3: {
        // value: "300+",
        label: "Expert technical support",
      },
      item4: {
        // value: "100+",
        label: "Rapid and flexible operations",
      },
      button: "Contact us",
    },
    section_4: {
      headline:
        "We focus on delivering what matters most to our customers with precision and care",
      description:
        "By consciously channeling our energy into what truly matters, we ensure our offerings align with customer demands and implement them with agility and flexibility. We count on technical experts at the local level to provide comprehensive support to customers and growers throughout the entire commercial process, from selecting and using our products to post-use guidance and best practices.",
    },
    section_5: {
      title: "Building trust and partnerships for lasting success",
      description:
        "We are committed to building long-term relationships founded on trust, shared goals, and a vision for the future. This philosophy drives our partnerships with distributors, fostering collaboration through openness, inclusivity, and a win-win mindset. True to our roots, we place special emphasis on supporting entrepreneurs, empowering their growth and success",
      button: "Contact us",
    },
  },
  business_partners_page: {
    hero: {
      title: "Business Partners",
      headline: "Your trusted partner for sustainable growth",
      button_1: "our solutions",
      button_2: "get in touch",
    },
    section_1: {
      title:
        "Driving global growth through tailored solutions, adaptability, and strong partnerships.",
      text: `The Business Partners Unit is the foundation of our company and where our journey began in 2000. Focused exclusively on B2B, it is the cornerstone of our global operations and the driving force behind our growth, innovation, and flexibility.
            
            This unit laid the groundwork for the Business Solutions Platform, designed to address the diverse contexts and unique needs of our partners worldwide.By crafting solutions that cater to varying markets, we’ve honed the adaptability that defines us as a company.In many countries, our presence begins here, establishing a foothold and building the capabilities required to meet the most rigorous market standards. 
            
            Our dedication to understanding and meeting our partners’ needs has not only fostered mutual growth but also shaped our ability to offer tailored business models.These range from registration and regulatory support to manufacturing and delivery aligned with specific requirements.

            With teams operating in over 100 countries, we’re committed to expanding our global presence at a steady and robust pace.Through our collaborative approach, we aim to empower our partners with the tools, flexibility, and services they need to thrive.`,
    },
    section_2: {
      text_regular_start:
        "Business Partners is our dedicated B2B unit. The name reflects the spirit of our daily interactions with customers—we view them as true partners and prioritize building ",
      text_color: "long-term ",
      text_regular_end:
        "relationships. This is where the company’s journey began—offering services exclusively to other businesses.",
    },
    section_3: {
      title: "Tailored partnerships for global growth and innovation",
      description: `We tailor our business models to meet the unique needs of our partners, adapting to diverse contexts and requirements.As a full - spectrum partner, we offer everything from generic to niche formulations, complemented by relevant registration services as needed, while adhering to each market's regulatory and quality standards. 

            The year 2025 marks a significant milestone for Business Partners as we celebrate our 25th anniversary.By this date, we will have established a presence in over 100 markets.As one of the youngest companies to rank within the Global Top 10, we continue to expand rapidly, driven by key markets in Europe, Australia, and Africa.

            Our business models are designed for flexibility, enabling us to deliver a wide range of formulations and provide robust registration support.This approach allows our partners to expand their portfolios seamlessly, leveraging our manufacturing expertise and global registration assets, if needed.`,
      button: "Contact us",
    },
    section_4: {
      headline: "Let's grow together!",
      description:
        "If you're seeking a partner to help you expand your offerings with proven quality and exceptional business value, contact us today.",
      item1: {
        // value: "7,000+",
        label: "7,000+ Registrations worldwide",
      },
      item2: {
        // value: "5,000+",
        label: "9 World class production factories",
      },
      item3: {
        // value: "300+",
        label: "End-to-end integration",
      },
      item4: {
        // value: "100+",
        label: "Long term partnerships",
      },
      button: "Contact us",
    },
    contact: {
      title: "Contact us",
      headline:
        "Get in touch with us to learn more and explore how we can support your business needs",
    },
  },
  bio_solutions_page: {
    hero: {
      title: "Bio Solutions",
      description:
        "At Rainbow Bio, we bring cutting-edge biological solutions to farmers worldwide, combining innovation with sustainability. No matter where you are, we help you grow stronger, smarter, and more sustainably—driving the future of agriculture for a resilient tomorrow.",
      button: "discover now",
      link: "Get more information",
    },
    section_1: {
      text_regular_1: "Rainbow Bio has recently embarked on its ",
      text_color_1: "journey",
      text_regular_2:
        ", launching its inaugural portfolio of products in Q4 2024. Recognizing the deep connection between growth, profitability, and ",
      text_color_2: "sustainability",
      text_regular_3: ", we lead the way in agricultural ",
      text_color_3: "innovation.",
    },
    section_2: {
      title: "Pioneering biological solutions for the future of agriculture",
      description: `By integrating biological products with traditional solutions, we aim to
  shape a future where growth is achieved through balance and efficiency.Our portfolio harnesses the power of nature to drive sustainable and profitable growth.From enhancing nutrient uptake to boosting crop yield and quality, our solutions are key to smarter, more efficient farming.Because at Rainbow Bio, growth is a commitment.

  We are shaping the future of agriculture.Understanding that biological solutions are key to future agricultural growth, Rainbow has created the Bio Innovation Hub, a collaborative platform to bring together expertise from all necessary fields.

  Rainbow BIO INNOVATION HUB unites key strategic partners, biological technical experts, and Rainbow’s teams in Commercial, Portfolio Management, R & D, and Marketing.Together, they work to deliver high - performing biological solutions, specifically tailored to meet the unique needs of farmers in the key countries we serve.`,
      button: "contact us",
    },
    section_3: {
      title:
        "Driving Growth Through Innovation: Empowering Farmers with Biological Solutions",
      description: `This initiative ensures that every solution we develop is driven by innovation, collaboration, and a deep understanding of the challenges farmers face—making bio not just a tool, but a way to grow.

  Our goal is to ensure that every farmer can thrive and grow with the best biological solutions.Together, we are driving a new era of growth—not just for your crops, but for the entire agricultural industry.`,
      button: "our solutions",
    },
  },
  non_crop_page: {
    hero: {
      title: "Enviro Solutions",
      headline: "Pioneering solutions for Enviro markets",
      button_2: "get in touch",
    },
    section_1: {
      subtitle: `As the world rapidly evolves, the demand for safe and sustainable ecosystems continues to grow and that’s why we have created Rainbow Enviro.`,
      text: `Rainbow Enviro is committed to meeting this need by delivering tailored solutions for non - crop markets.These include spaces where people live, work, and play—such as recreational turf, gardens, forestry, waterways, buildings, infrastructure, and more.

By addressing the needs of these spaces, Rainbow Enviro plays a vital role in fostering outdoor lifestyles, strengthening connections with nature, and ensuring harmony with the spaces where our communities thrive.`,
    },
    section_2: {
      text_color: "Solutions",
      text_regular: " for thriving communities and ecosystems",
    },
    section_3: {
      title: "RAINBOW Enviro SOLUTIONS",
      headline: "Sustainable solutions for Enviro ecosystems",
      description: `At Rainbow Enviro, we specialize in innovative crop protection solutions designed to enhance green spaces and improve the quality of life for communities.Our mission is to deliver effective, safe, and environmentally sustainable solutions that protect people, plants, and properties from pests, diseases, and weeds—while safeguarding surrounding ecosystems.

With a global team of experts in manufacturing, formulation, agronomy, and science, we produce high - quality, high - performance products that address the diverse needs of non - crop users.

Driven by a commitment to research and development, we continually enhance our solutions to align with the latest industry advancements and regulatory standards.`,
      button: "contact us",
    },
    services: {
      title: "ENVIRO SOLUTIONS UNITS",
      headline: "",
      description: "",
      item1: {
        title: "Turf and Landscapes",
        description:
          "Professional turf and landscape management requires consistent, high-quality playing surfaces while balancing budgets, environmental responsibility, and community expectations.\n\nRainbow Enviro delivers innovative, environmentally responsible solutions for managed green spaces. Backed by global expertise in manufacturing, formulation, and synthesis, our products provide consistent performance season after season.",
      },
      item2: {
        title: "Pest Management",
        description:
          "Professional pest managers protect communities in highly regulated environments. Rainbow Enviro delivers trusted, high-performance solutions that provide dependable control and support compliance.\n\nBacked by advanced manufacturing and rigorous quality assurance, we deliver consistent, high-quality solutions professionals can rely on season after season.",
      },
      item3: {
        title: "Ornamentals",
        description:
          "Exceptional plants require expertise, precision, and care. Rainbow Enviro provides advanced plant protection solutions that defend crop health, minimize production risk, and support long-term growing success.\n\nBacked by advanced manufacturing and strict quality standards, our solutions deliver reliable performance growers can trust.",
      },
      item4: {
        title: "Vegetation Management",
        description:
          "Effective vegetation management is essential to protect critical infrastructure, from power lines and transport corridors to pipelines, industrial sites, and public assets. Rainbow Enviro delivers advanced vegetation management solutions that provide reliable, long-lasting control while supporting safe and efficient operations.\n\nBacked by advanced manufacturing and strict quality standards, our solutions deliver consistent performance professionals can trust.",
      },
    },
    section_4: {
      title: "Rainbow Enviro Enviro Solutions",
      headline: "Our commitments",
      button: "CONTACT US",
      values: {
        item1: {
          title: "We Believe in Balance",
          description:
            "At Rainbow Enviro, we are dedicated to protecting the environments we share. Our mission goes beyond crop protection to promote harmony between people and nature, ensuring that communities can thrive.",
        },
        item2: {
          title: "We Embrace Innovation",
          description:
            "In a constantly evolving world, we remain at the forefront of technology and research to develop solutions that are both highly effective and sustainable.",
        },
        item3: {
          title: "We Prioritize Sustainability",
          description:
            "Our planet is our most precious resource. We are dedicated to practices that protect and preserve ecosystems, delivering solutions that enhance green spaces while supporting the health and vitality of the surrounding environment.",
        },
      },
    },
    section_5: {
      headline:
        "Join us on a journey toward a greener, healthier future. Together, we can cultivate thriving spaces that balance the needs of people and nature, ensuring a sustainable planet for generations to come.",
    },
  },
  design_page: {
    hero: {
      title: "RAINBOW DESING STUDIO",
      headline: "A collaborative hub for tailored solutions",
      button: "get in touch",
    },
    section_1: {
      text: "The Rainbow Design Studio is a dedicated physical space in the Chicago Area where Rainbow collaborates with global brands to co-create  product and supply chain solutions that deliver win-win outcomes. This highly collaborative process unlocks the full spectrum of solutions that Rainbow offers to drive supply chain efficiency, optimize working capital and facilitate",
      button: "contact us",
    },
    section_2: {
      column_1: "Great ideas thrive when the right people collaborate",
      column_2: `In conversations with our customers, we discovered that a collaborative environment is essential to achieving meaningful results and strengthening partnerships.This insight inspired the Design Studio, driven by a simple yet powerful realization: “Great ideas die because all the right people aren’t in the room.”`,
      column_3: `We recognize that a customer’s journey to launching a product is fraught with challenges, impacting efficiency and costs.The most complex phases often involve cross - functional coordination and with external partnerships.Cohesion, collaboration, and clear alignment are critical to delivering solutions that drive business success.`,
    },
    section_3: {
      text_start: `Our`,
      text_bold: `Business Solutions Platform`,
      text_end: `, offers flexible, cost - efficient solutions tailored to diverse business models.The Design Studio complements this platform  by creating the environment needed to collaboratively create and deliver custom solutions while maintaining the speed, agility, and cost efficiency required by the industry.`,
    },
    section_4: {
      title: "RAINBOW DESIGN STUDIO",
      headline: "A Curated Customer Experience",
      subtitle:
        "The Design Studio offers a structured, three-phase experience to ensure a personalized and impactful journey:",
      items: {
        item_1: {
          title: "Discovery and Planning",
          description_1: `The first phase focuses on understanding and acknowledging customer needs, building confidence in the design process.`,
          list_item_1: `Key customer team members participate in personal interviews, ensuring the right inputs and stakeholders are identified for the workshop session.`,
          list_item_2: `This step establishes trust and sets the foundation for a productive experience.`,
        },
        item_2: {
          title: "Interactive Design Experience",
          description_1: `This phase showcases Rainbow’s global capabilities while hosting workshops tailored to the customer’s development needs.`,
          list_item_1: `Workshops cover a range of areas, including product design, regulatory compliance, supply chain solutions, and cost modeling.`,
          list_item_2: `The interactive format ensures all critical aspects are addressed collaboratively.`,
        },

        item_3: {
          title: "Final Output and Action Plan",
          description_1: `The process concludes with a comprehensive product design kit, including:`,
          list_item_1: "An overview presentation.",
          list_item_2: "Rainbow’s tailored proposal.",
          list_item_3: "A detailed project plan with a Gantt timeline.",
        },
      },
      button: "contact us",
    },
    section_5: {
      text: `This collaborative, structured approach ensures customers leave with actionable solutions aligned to their business objectives, making the Rainbow Design Studio a cornerstone of innovation and partnership.`,
    },
  },
  solutions_page: {
    hero: {
      headline: "Your one stop shop for complete solutions",
      subtitle:
        "We offer solutions to protect crops from all types of weeds, pests, and diseases at every stage of growth.",
      b2c_title: "Find products available in your country/area",
      b2c_description:
        "Select your country or area to explore our products available in your region. Discover tailored solutions designed to meet your needs and drive success.",
      b2c_search_placeholder: "Select your country / Area",
      b2b_title: "Are you a distributor or represent a company?",
      b2b_description:
        "View our complete product portfolio and connect with us to explore opportunities for growth and partnership. Let’s grow together!",
      b2b_button: "EXPLORE AND CONNECT",
    },
    section_2: {
      title: "our solutions",
      headline: "Your one stop shop for complete solutions",
      description:
        "We offer solutions to protect crops from all types of weeds, pests, and diseases at every stage of growth.",
      modal_select_country_title: "Find the perfect solutions for you",
      modal_select_country_message:
        "Select your country or region to explore the products available in your area.If you represent a company or are a distributor, choose to view our complete global portfolio and discover how we can grow together.",
      modal_select_country_button: "Please select your country",
    },
    section_3: {
      headline: "Let's grow together!",
      description:
        "We are dedicated to expanding our portfolio, whether through new registrations or advancements in our R&D centers and factories. Our unwavering focus is on delivering these solutions to ensure we grow, together!",
      item1: {
        value: "7,000+",
        label: "Registration Worldwide",
      },
      item2: {
        value: "5,000+",
        label: "Production Formulas",
      },
      item3: {
        value: "300+",
        label: "Patents",
      },
      item4: {
        value: "1,200+",
        label: "New registrations annually",
      },
      button: "Learn more",
    },
    section_4: {
      title: "GLOBAL PRESENCE",
      headline: "Discover all products available in your country / area",
      subtitle: "We’re wherever you need us.",
      form_country_placeholder: "Select Your Country / area",
      form_country_label: "Country / area",
      form_country_link: "See available products"
    },
    section_5: {
      title: "VALUES PROPOSAL",
      headline: "Why choose Rainbow?",
      button: "CONTACT US",
      values: {
        item1: {
          title: "Portfolio Strength",
          description:
            "With over 5,000 formulations and 7,000 registrations worldwide, we offer solutions that address crop challenges at every growth stage.",
        },
        item2: {
          title: "Convenient Value",
          description:
            "From concept to delivery, our end-to-end approach ensures full control over product quality while achieving cost efficiencies across the entire supply chain.",
        },
        item3: {
          title: "Efficient Services",
          description:
            "Our customer-centric culture ensures high-quality services that address what matters the most to customers and growers.",
        },
        item4: {
          title: "Reliable Partnership",
          description:
            "We build trust by consistently delivering on commitments, fostering strong, long-term customer relationships.",
        },
      },
    },
  },
  news_page: {
    hero: {
      headline: "Our news",
      description:
        "Stay updated with the latest news, insights, and achievements from our team. Discover how we're shaping the future of agroiculture with innovation and dedication.",
    },
    widget: {
      latest_posts: "Latest posts",
      posted_by: "Posted by",
    },
  },
  contact_page: {
    hero: {
      title: "CONTACT US",
      headline: "Say hello and start growing with us",
    },
    section_1: {
      title: "Let's talk",
      description:
        "We’re here to help you grow. Fill out the form below, and one of our experts will get in touch with you shortly. Let’s start building something great together!",
      say_hello: "Say hello",
      location: "Location",
    },
    section_2: {
      title: "Frequently asked questions",
      description:
        "Find quick answers to our customers' most common questions. Expand each section to get the information you need.",
      values: {
        value_1: {
          title: "In which countries do you operate?",
          description:
            "Rainbow operates in more than 100 countries, with varying levels of service units. For information about our operations in a specific country / area, please select the country / area in the “Our Company” section and access the local website.",
        },
        value_2: {
          title: "How long has the company been in business?",
          description:
            "Rainbow began its operations in the year 2000. It is the newest company within the Global Top 10 ranking in the crop protection industry.",
        },
        value_3: {
          title: "What crop protection products do you offer?",
          description:
            "Our portfolio includes over 5,000 formulations and 7,000 registrations globally, with an additional 800–1,200 registrations added annually. We provide a complete crop protection solutions portfolio, including herbicides, pesticides, fungicides, plant growth regulators (PGRs), and a biosolutions platform. Our portfolio addresses the diverse challenges of weeds, pests, and diseases farmers face at all crop stages—from pre-planting to over-the-top applications—ensuring our customers can meet their needs with a single supplier.",
        },
        value_4: {
          title: "What is your approach to developing off-patent products?",
          description:
            "Rainbow focuses on producing off-patent solutions, offering a broad and robust portfolio, world-class quality standards, and convenient value. Our operations prioritize maximum efficiency across production processes, shipping, and market analysis.",
        },
        value_5: {
          title: "Do you offer customized formulations?",
          description:
            "With two state-of-the-art Research Centers, one Process Development Center, and more than 300 patents, we can rapidly customize a wide range of products, from niche to generics. Our lead times range from a minimum of 45 days to a maximum of 95 days. We specialize in developing differentiated and innovative formulations to add value for our customers.",
        },
        value_6: {
          title:
            "How can I access product labels and Safety Data Sheets (SDS)?",
          description:
            "These are available on the local websites in the “Solutions” section. Each product page provides the relevant documentation for download.",
        },
        value_7: {
          title: "Do you partner with distributors or directly with farmers?",
          description:
            "Our primary focus is on partnering with distributors. We invest in channel development, honor agreements, and respect channel strategies to ensure business success for all channel customers.",
        },
        value_8: {
          title: "How can I become a distributor or business partner?",
          description: "Contact us, and we’ll get back to you promptly!",
        },
        value_9: {
          title:
            "How do you ensure regulatory compliance across different regions?",
          description:
            "We have expert teams in every country where we operate. They ensure our products are successfully registered on time and comply with all regulatory guidelines.",
        },
        value_10: {
          title: "What certifications do your production facilities hold?",
          description: `Our facilities meet world- class standards and hold multiple certifications.Being the following the most important ones:
        ISO certificates：ISO9001 certificate、ISO14001 certificate、ISO45001 certificate
                CNAS: At Rainbow, all our testing works are performed in CNAS accredited laboratories.CNAS stands for China National Accreditation Service for Conformity Assessment.Thus, laboratories recognized by CNAS can obtain recognition from accredited institutions in the country and region where the mutual recognition agreement is signed for their testing reports.
                In terms of quality our product complies with the following international standards.
                - Quality standards for pesticide products developed by the Food and Agriculture Organization of the United Nations/ World Health Organization(FAO / WHO)
    - China National Standards for Pesticides Products
        - Industrial Standards for Pesticides Products
            - The pesticide quality analysis method CIPAC developed by The International Pesticide Analysis Council
                - Anti - cross contamination guide—2019 version
                    - Residue standards of the EU Pesticide Database
                        - The Control Standards for Common Impurities in Pesticide Active Ingredients
                `,
        },
        value_11: {
          title:
            "Can I request specific documentation or certifications for a product?",
          description:
            "Yes, specific documentation and certifications are available upon request. Please contact us with your requirements.",
        },
        value_12: {
          title: "How can I apply for a job with your company?",
          description: "Reach out to us and submit your resume!",
        },
        value_13: {
          title: "Where can I find a sales representative in my region?",
          description:
            "Use the country / area selector to navigate to the local website, where you can leave a message. Our team will contact you shortly.",
        },
        value_14: {
          title: "How can I contact the Support Center?",
          description:
            "Fill out the contact form, and we’ll get back to you promptly.",
        },
      },
    },
  },
  country_product_list_page: {
    hero: {
      title: "Solutions",
      headline: "Discover Our Product Portfolio",
      subtitle:
        "Explore our extensive range of products designed to meet diverse needs. At Rainbow, we deliver reliable solutions that drive growth. Whether you’re looking for crop protection, seed treatments, or specialized solutions, our portfolio showcases the quality and expertise that define us.",
    },
    filter_section: {
      dropdown_product_family: "Product Family",
      dropdown_crop: "Crop",
      dropdown_active_ingredient: "Active Ingredient",
      dropdown_problematic: "Problematic",
      dropdown_formulation_type: "Formulation Type",
      dropdown_concentration: "Concentration",
      catalog_button: "View our catalog",
    },
  },
  country_product_single_page: {
    hero: {
      active_ingredients: "active ingredients",
      type_of_formulation: "type of formulation",
    },
    widget: {
      related_documents: "Related Documents",
      Toxicological_class: "Toxicological Class",
      problematic: "Problematic",
      crops: "Crops",
      calibre: "Calibre",
    },
    contact_form: {
      title: "",
      input_name_label: "",
      input_name_placeholder: "",
      input_email_label: "",
      input_email_placeholder: "",
      input_message_label: "",
      input_message_placeholder: "",
      submit_button: "",
      agreement_text:
        "All the fields are required. By sending the form you agree to the",
      terms_link: "Terms & Conditions",
      and: "and",
      privacy_link: "Privacy Policy",
      errors: {
        name: "Name is required",
        email: "Email is required",
        message: "Message is required",
        min_name: "Name must be at least 3 characters",
        invalid_email: "Please enter a valid email address",
      },
    }
  },
  country_product_commerce_page: {
    hero: {
      title: "OUR PRODUCTS",
      headline: "Our products available in [Country Name]",
      subtitle:
        "Explore our extensive range of products designed to meet diverse needs. At Rainbow, we deliver reliable solutions that drive growth. Whether you’re looking for crop protection, seed treatments, or specialized solutions, our portfolio showcases the quality and expertise that define us.",
    },
    filter: {
      title: "Filter by Category",
      subtitle: "Select the product family or category to find the solutions you need.",
      placeholder: "Filter by Category"
    },
    table_of_products: {
      header_1: "active ingredient",
      header_2: "product name",
      header_3: "reg. no.",
    },
    contact_form: {
      title: 'Contact us today!'
    },
    section_2: {
      text_start: "We believe that",
      text_color: "together we can grow",
      text_end: "a better future",
    },
  },
  country_product_contact_page: {
    hero: {
      title: "OUR PRODUCTS",
      headline: "Let’s find the right solution for you",
      subtitle:
        "We’re here to help you grow. If you’re looking for Rainbow products or tailored solutions for your region, let’s connect! Complete the form below, and our team will reach out to explore how we can support your needs and create the best opportunities together.",
    },
    title_form: "Contact us today!",
    section_2: {
      text_start: "We believe that",
      text_color: "together we can grow",
      text_end: "a better future",
    },
  },
  global_product_list_page: {
    hero: {
      title: "OUR PRODUCTS",
      headline: "Explore our global product portfolio",
      subtitle:
        "Discover the full range of solutions Rainbow offers worldwide. Our extensive portfolio includes innovative products designed to meet the diverse needs of our customers, from crop protection to seed treatments and Enviro solutions.",
      subtitle_bold: "Start exploring and discover what Rainbow can do for your business."
    },
    filter: {
      title: "Filter by Category",
      subtitle: "Select the product family or category to find the solutions you need.",
      placeholder: "Filter by Category"
    },
    table_of_products: {
      header: "product name"
    },
    section_2: {
      text_start: "We believe that",
      text_color: "together we can grow",
      text_end: "a better future",
    },
  },
};
